import React, { useEffect, useState, useContext, useRef } from 'react';
import { IonButton, IonSlides, IonGrid, IonTabs, IonTab, IonTabBar, IonTabButton, IonToolbar, IonTitle, IonContent, IonHeader, IonLabel, IonRouterOutlet, IonFooter, IonCard, IonList, IonItem, IonicSlides, IonText, IonIcon, IonPopover } from '@ionic/react';
import { IonSlide, IonRow, IonCol, IonImg } from '@ionic/react';
import '../css/zPublic.css';

import {Retail_Homepage} from '../components/Homepage_retail';

import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';

import { GPSC_Component } from './Merchant_GeoLocation';
import {CachedImage} from './Component_CachedImage'; // Import CachedImage component

import { checkmarkCircleOutline } from 'ionicons/icons';


export function Home_RetailServicesList (props) 
{

    let authMerchant_objects = useContext(Auth_MerchantID_context);

    let [baseURL, setBaseURL ] = useState(authMerchant_objects.baseURL);

    let [viewMerchantList_retailServices, setViewMerchantList_retailServices] = useState([]);

    let [companyID, setCompanyID] = useState(null);
    let [companySchema, setCompanySchema] = useState(null);
    let [companyName, setCompanyName] = useState(null);
    let [companyAddressNumber, setCompanyAddressNumber] = useState(false);
    let [companyStreetName, setCompanyStreetName] = useState(false);
    let [companyCity, setCompanyCity] = useState(false);
    let [companyCityDistrict, setCompanyCityDistrict] = useState(false);
    let [companyPhoneNumber, setCompanyPhoneNumber] = useState(false);
    let [companyEmail, setCompanyEmail] = useState(false);
    let [customerRating, setCustomerRating] = useState('0.00000');
    let [companyLatitude, setCompanyLatitude] = useState(null);
    let [companyLongitude, setCompanyLongitude] = useState(null);
    let [retailHompageModal, setRetailHomepageModal] = useState(false);

    let [merchantID, setMerchantID] = useState(null);
    let [merchantName, setMerchantname] = useState(null);
    let [merchantMomoNumber, setMerchantMomoNumber] = useState(null);
    let [merchantUpload_ghanaID, setmerchantUpload_ghanaID] = useState(null);
    let [merchantUpload_businessRegistrationID, setMerchantUpload_businessRegistrationID] = useState(null);
    let [merchantAddress, setMerchantAddress] = useState(null);
    let [merchantLatitude, setMerchantLatitude] = useState(null);
    let [merchantLongitude, setMerchantLongitude] = useState(null);
    let [merchantUpload_companyMainImage, setMerchantUpload_companyMainImage] = useState(null);

    let [viewIonPopover, setViewIonPopover] = useState(false);


    useEffect(() => {
        

        setViewMerchantList_retailServices([]);

            const requestOptions = {
                method:'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                 },
                body: JSON.stringify({
                    Tracker: "0002_retail",
    
                })            }
    
            //alert('In ghanaverifiedApp - HotelList UseEffect');

            fetch(baseURL+'merchants_argsApp', requestOptions)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');
                for(let rowNum = 0; rowNum < rows.length - 1; ++rowNum)
                {
                 
                    let cols_spit = rows[rowNum].split('#');
                    let cols = cols_spit[0].split('|');
                    let cols_1 = cols_spit[1].split('|');

                    //alert("Splitting Columns");
                    //alert(cols_spit);
                    //alert(cols);
                    //alert(cols_1);


                    setViewMerchantList_retailServices((prevViewMerchantList_hotels) => {
                        return prevViewMerchantList_hotels.concat({
                            companyAcctID: cols[0],
                            companyName: cols[1],
                            companyAddressNumber: cols[2],
                            streetName: cols[3],
                            city: cols[4],
                            cityDistrict: cols[5],
                            companyPhoneNumber: cols[6],
                            companyEmail: cols[7],
                            companyImage: cols[8],
                            companySchema: cols[9],
                            customerRating: cols[10],
                            latitude: cols[11],
                            longitude: cols[12],
                            merchantID: cols_1[0], 
                            merchantName: cols_1[1],
                            merchantMomoNumber: cols_1[2],
                            merchantUpload_ghanaID: cols_1[3],
                            merchantUpload_businessRegistrationID: cols_1[4],
                            merchantAddress: cols_1[5],
                            latitude: cols_1[6],
                            longitude: cols_1[7],
                            merchantUpload_companyMainImage: cols_1[8],
                            companyShowcase: cols_1[9],
                            date_logged: cols_1[10],
                            onboardingStatus: cols_1[11],
                        })

                        
                    });


                }

                props.confirmComplete();
            })
    }, []);


    function zPub_selectMerchantID(e)
    {
        //e.preventdefault();

        // alert("In zPub");
        // alert(e[1]);
        //alert(e[9]);

        //props.merchantIDB(e);
        //authMerchant_objects.changeAccountID(e[1]);
        setCompanyID(e[1]);
        setCompanySchema(e[2]);
        setCompanyName(e[3]);
        setCompanyAddressNumber(e[4]);
        setCompanyStreetName(e[5]);
        setCompanyCity(e[6]);
        setCompanyCityDistrict(e[7]);
        setCompanyEmail(e[8]);
        setCompanyPhoneNumber(e[9]);
        setCustomerRating(e[10]);
        setCompanyLatitude(e[11]);
        setCompanyLongitude(e[12]);

        setRetailHomepageModal(e[0]);

    }

    function setViewIonPopoverHandler(event)
    {

        setMerchantID(event[0]);
        setMerchantname(event[1]);
        setMerchantMomoNumber(event[2]);
        setmerchantUpload_ghanaID(event[3]);
        setMerchantUpload_businessRegistrationID(event[4]);
        setMerchantAddress(event[5]);
        setMerchantLatitude(event[6]);
        setMerchantLongitude(event[7]);
        setMerchantUpload_companyMainImage(event[8]);
        setViewIonPopover(true);
    }

   //alert('In begining retail');
//alert(viewMerchantList_retailServices.length);

useEffect(() => {
    if (viewIonPopover) {
      document.body.style.overflow = 'hidden';  // Freeze background
    } else {
      document.body.style.overflow = 'auto';    // Restore scroll
    }
    return () => {
      document.body.style.overflow = 'auto';    // Clean up on unmount
    };
  }, [viewIonPopover]);


        return (
            <React.Fragment>


               {viewMerchantList_retailServices.length == 0 && <div className='zList_companyImage_list'>

                    <IonCard className='card_merchantList'>

                            <div className='zList_img'>

                                {/*<IonImg className='zList_img_inside' src={detailData.companyImage}></IonImg>*/}
                                <h2>LOADING</h2>
                            </div>

                    {/*} </IonButton>*/}
                    </IonCard>

                    </div>}

                    

               {viewMerchantList_retailServices.length > 0 && <div className='zList_companyImage_list'>


                    {viewIonPopover && (

                        <IonPopover
                        isOpen={viewIonPopover}
                        onDidDismiss={() => setViewIonPopover(false)}
                        className="custom-popover"
                        >

                        <IonGrid className='custom-popover-grid'>
                            <IonRow >
                                <IonCol size='6'>
                                    <IonText style={{ color: 'black', fontSize: '.5em' }}>Business Owner</IonText>
                                </IonCol>
                                <IonCol size='6'>
                                    <IonText style={{ color: (merchantName != 'NULL' && merchantMomoNumber != 'NULL' && merchantUpload_companyMainImage != 'NULL') ? 'green' : 'red', fontSize: '.5em' }}>
                                    {(merchantName !== 'NULL' && merchantMomoNumber !== 'NULL' && merchantUpload_companyMainImage !== 'NULL') ? 'Verified' : 'Not Verified'}
                                    </IonText>
                                </IonCol>
                            </IonRow>
                            <IonRow >
                                <IonCol size='6'>
                                    <IonText style={{ color: 'black', fontSize: '.5em' }}>Ghana ID</IonText>
                                </IonCol>
                                <IonCol size='6'>
                                    <IonText style={{ color: (merchantUpload_ghanaID != 'NULL') ? 'green' : 'red', fontSize: '.5em' }}>
                                    {(merchantUpload_ghanaID != 'NULL') ? 'Verified' : 'Not Verified'}
                                    </IonText>
                                </IonCol>
                            </IonRow>
                            <IonRow >
                                <IonCol size='6'>
                                    <IonText style={{ color: 'black', fontSize: '.5em' }}>Business Location</IonText>
                                </IonCol>
                                <IonCol size='6'>
                                    <IonText style={{ color: (merchantAddress != 'NULL' && merchantLatitude != 'NULL' && merchantLongitude != 'NULL') ? 'green' : 'red', fontSize: '.5em' }}>
                                        {(merchantAddress != 'NULL' && merchantLatitude != 'NULL' && merchantLongitude != 'NULL') ? 'Verified' : 'Not Verified'}
                                    </IonText>
                                </IonCol>
                            </IonRow>
                            <IonRow >
                                <IonCol size='6'>
                                    <IonText style={{ color: 'black', fontSize: '.5em' }}>Business Certificate</IonText>
                                </IonCol>
                                <IonCol size='6'>
                                    <IonText style={{ color: (merchantUpload_businessRegistrationID != 'NULL') ? 'green' : 'red', fontSize: '.5em' }}>
                                    {(merchantUpload_businessRegistrationID != 'NULL') ? 'Verified' : 'Not Verified'}
                                    </IonText>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol size='12'>
                                    <IonButton onClick={(e) => {e.stopPropagation(); setViewIonPopover(false)}}>close</IonButton>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                        </IonPopover>
                        )} 



                    {viewMerchantList_retailServices.map((detailData) =>   {
                                return (
                                    
                                    <IonGrid>
                                        <IonRow>
                                            <IonCol size='12'>
                                                { (detailData.merchantName != 'NULL' && detailData.merchantMomoNumber != 'NULL' && detailData.merchantUpload_companyMainImage != 'NULL' && detailData.merchantUpload_ghanaID != 'NULL' && detailData.merchantUpload_businessRegistrationID != 'NULL' && detailData.merchantAddress != 'NULL' && detailData.latitude != 'NULL' && detailData.longitude != 'NULL')  && <IonIcon icon={checkmarkCircleOutline} style={{ color: 'green', fontSize: '1.5em' }} onClick={(e) => { 
                                                                                                                                                        e.stopPropagation(); 
                                                                                                                                                        setViewIonPopoverHandler([detailData.merchantID, detailData.merchantName, detailData.merchantMomoNumber, detailData.merchantUpload_ghanaID, detailData.merchantUpload_businessRegistrationID, detailData.merchantAddress, detailData.latitude, detailData.longitude, detailData.merchantUpload_companyMainImage]);
                                                                                                                                                        // Optional: open popover logic here
                                                                                                                                                        }} /> }
                                                { ((detailData.merchantName == 'NULL' || detailData.merchantMomoNumber == 'NULL' || detailData.merchantUpload_companyMainImage == 'NULL') && detailData.merchantUpload_ghanaID == 'NULL' && detailData.merchantUpload_businessRegistrationID == 'NULL' && (detailData.merchantAddress == 'NULL' || detailData.latitude == 'NULL' || detailData.longitude == 'NULL'))  && <IonIcon icon={checkmarkCircleOutline} style={{ color: 'red', fontSize: '1.5em' }} onClick={(e) => { 
                                                                                                                                                        e.stopPropagation(); 
                                                                                                                                                        setViewIonPopoverHandler([detailData.merchantID, detailData.merchantName, detailData.merchantMomoNumber, detailData.merchantUpload_ghanaID, detailData.merchantUpload_businessRegistrationID, detailData.merchantAddress, detailData.latitude, detailData.longitude, detailData.merchantUpload_companyMainImage]);
                                                                                                                                                        // Optional: open popover logic here
                                                                                                                                                        }} /> }
                                                { !(
                                                    (detailData.merchantName !== 'NULL' &&
                                                    detailData.merchantMomoNumber !== 'NULL' &&
                                                    detailData.merchantUpload_ghanaID !== 'NULL' &&
                                                    detailData.merchantUpload_businessRegistrationID !== 'NULL' &&
                                                    detailData.merchantAddress !== 'NULL' &&
                                                    detailData.latitude !== 'NULL' &&
                                                    detailData.longitude !== 'NULL' &&
                                                    detailData.merchantUpload_companyMainImage !== 'NULL') ||
                                                    ((detailData.merchantName === 'NULL' ||
                                                    detailData.merchantMomoNumber === 'NULL' ||
                                                    detailData.merchantUpload_companyMainImage === 'NULL') &&
                                                    detailData.merchantUpload_ghanaID === 'NULL' &&
                                                    detailData.merchantUpload_businessRegistrationID === 'NULL' &&
                                                    (detailData.merchantAddress === 'NULL' ||
                                                    detailData.latitude === 'NULL' ||
                                                    detailData.longitude === 'NULL'))
                                                    ) && (
                                                    <IonIcon icon={checkmarkCircleOutline} style={{ color: 'goldenrod', fontSize: '1.5em' }}
                                                        onClick={(e) => { 
                                                        e.stopPropagation(); 
                                                        setViewIonPopoverHandler([detailData.merchantID, detailData.merchantName, detailData.merchantMomoNumber, detailData.merchantUpload_ghanaID, detailData.merchantUpload_businessRegistrationID, detailData.merchantAddress, detailData.latitude, detailData.longitude, detailData.merchantUpload_companyMainImage]);
                                                    }} 
                                                    />
                                                )}
                                            </IonCol>
                                        </IonRow>
                                        <IonRow>
                                            <IonCol size='12'>
                                                <IonCol className='zPub_list_gridCol_title'>{detailData.companyName}</IonCol>
                                            </IonCol>
                                        </IonRow>
                                        <IonRow>
                                            <IonCol>
                                                <IonCard className='card_merchantList'>
                                                    <IonButton className='hidden_button' key={detailData.companyAcctID} fill='clear' onClick={ () => zPub_selectMerchantID([true, detailData.companyAcctID, detailData.companySchema, detailData.companyName, detailData.companyAddressNumber, detailData.streetName, detailData.city, detailData.cityDistrict, detailData.companyEmail, detailData.companyPhoneNumber, detailData.customerRating, detailData.latitude, detailData.longitude]) } >
                        
                                                        <div className='zList_companyImage_list_div'>
                        
                                                            {/* <CachedImage  
                                                                imageUrl={detailData.companyImage}
                                                                fileName={detailData.companyImage} 
                                                                className="zList_companyImage_list_inside"
                                                                alt="Example Cached Image"
                                                                        ></CachedImage>*/}

                                                                <IonImg className="zList_companyImage_list_inside" src={`/api/image/${detailData.companyImage}/${detailData.companySchema}`} />        
                                                        </div>

                                                        {/*<IonGrid className='gridMain_merchantList_bottom'>
                                                            <IonRow >
                                                                <IonCol className='zPub_gridCol'>{detailData.customerRating}</IonCol>
                                                            </IonRow>
                                                            </IonGrid>*/}
                                                    </IonButton>
                                                </IonCard>
                                            </IonCol>
                                        </IonRow>
                                        <IonRow>
                                            <IonCol>
                                            {((detailData.latitude != undefined && detailData.latitude != 'NULL') && (detailData.longitude != undefined && detailData.longitude != 'NULL')) && <GPSC_Component data={{
                                                    companyLatitude: detailData.latitude, 
                                                    companyLongitude: detailData.longitude,
                                                    }}></GPSC_Component>}
                                            </IonCol>
                                        </IonRow>  
                                    </IonGrid>
                                );
                            })}
                </div>}


                {retailHompageModal == true && <Retail_Homepage openModal={retailHompageModal} closeModal={() => setRetailHomepageModal(false)} data={{
                    companyId: companyID, 
                    companySchema: companySchema, 
                    companyName: companyName,
                    companyAddressNumber: companyAddressNumber,
                    companyStreetName: companyStreetName,
                    companyCity: companyCity,
                    companyCityDistrict: companyCityDistrict,
                    companyEmail: companyEmail,
                    companyPhoneNumber: companyPhoneNumber,
                    customerRating: customerRating,
                    }}></Retail_Homepage>}


            </React.Fragment>
        )










    /*let [viewMerchantList_retailServices, setViewMerchantList_retailServices] = useState([]);


    function zPub_selectMerchantID(e)
    {

        props.merchantIDB(e);

    }


        return (
            <React.Fragment>
                <IonSlides options={{direction: 'vertical'}}>

                        <IonSlide>
                            <IonCard className='card_merchantList'>
                                <h2>RETAIL LIST</h2>
                                <h2>COMING SOON</h2>
                            </IonCard>
                        </IonSlide>

                </IonSlides>
            </React.Fragment>
        )*/
}

